import { Link } from "react-router-dom";
const Home = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 text-center mt-5">
                        <img src={process.env.PUBLIC_URL + "/img/LOGO DESKTOP.png"} className="imageLogo" />
                    </div>
                    <div className="col-sm-12 mt-5 text-center">
                        <Link className="btn btn-azul" to="/registro_calaverita">
                            REGISTRARSE
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Home;